import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { TModalComponentsItemProps } from '../../types/productFeatureComponent.types';
import CTAWithArrow from '../../../CTAWithArrow';
import Banner from '../componentDetails/banner';
import CTA from '../../../CTA';
import ctaTypes from '../../../../../enums/CTA.enums';
import { targetLinkdsk } from '../../../../../utils/targetDskLink';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import breakpoints from '../../../../../constants/breakpoints.constants';
import { appendRootToRichTextInternalLinks } from '../../../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../../../utils/appendRootToInternalLink.utils';

const InnerSplitModule: FC<TModalComponentsItemProps> = (props) => {
  const model = props.component;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const link1 = {
    value: {
      href: model?.button1?.url,
      text: model?.button1?.label,
      target: model?.button1?.target,
    },
  };
  const link2 = {
    value: {
      href: model?.button2?.url,
      text: model?.button2?.label,
      target: model?.button2?.target,
    },
  };

  return (
    <div className="inner-split-module">
      <div className="inner-split-module__image-wrapper">
        <Banner
          component={model}
          mediaHeightClassName="inner-split-module__media-height"
          mediaCarouselClassName="inner-split-module__media-carousel"
          desktopRenditionKey="rendition_desktop_size1000"
          mobileRenditionKey="rendition_mobile_size500"
        />
      </div>
      <div className="inner-split-module__text-wrapper">
        <p className="inner-split-module__eyebrow">{model?.eyebrow}</p>
        <RichText editable={false} field={{ value: model?.title }} tag="h2" className="inner-split-module__title" />
        <RichText
          editable={false}
          field={{ value: appendRootToRichTextInternalLinks(model?.description) }}
          tag="div"
          className="inner-split-module__description rich-text"
        />
        <div className={'inner-split-module__buttons'}>
          {(model?.button1?.url || model?.button1?.label) && (
            <CTA
              type={ctaTypes.primaryOrange}
              extraClassName={'inner-split-module__primary-link'}
              field={{
                value: {
                  href: appendRootToInternalLink(model?.button1?.url),
                  text: model?.button1?.label,
                },
              }}
              target={targetLinkdsk(link1, isDesktop)}
            />
          )}
          {(model?.button2?.url || model?.button2?.label) && (
            <CTAWithArrow
              href={appendRootToInternalLink(model?.button2?.url) || ''}
              text={model?.button2?.label}
              target={targetLinkdsk(link2, isDesktop)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InnerSplitModule;
